import {FormattedMessage, defineMessages} from 'react-intl';
import {css, view} from '@sail/ui/deprecated';
import {VerificationCodes} from './VerificationCodes';

const messages = defineMessages({
  callout: {
    id: 'conversations_ui.rac.confirmation.title',
    description: 'The main callout on the request-a-call confirmation screen',
    defaultMessage: 'We got it! Keep this tab open',
  },
});

type Props = {
  name: string;
  phoneNumber: string;
  waitTime?: React.ReactNode;
  verificationCodes?: {
    userCode: string;
    agentCode: string;
  };
  verficationCodesLoading: boolean;
  verificationCodesError?: React.ReactNode;
};

export const Confirmation = ({
  name,
  phoneNumber,
  waitTime,
  verificationCodes,
  verficationCodesLoading = false,
  verificationCodesError,
}: Props) => {
  return (
    <view.div>
      <view.h2>
        <FormattedMessage {...messages.callout} />
      </view.h2>
      <view.div
        css={{
          display: css.value('flex'),
          flexDirection: css.value('column'),
          marginBottom: css.value('8px'),
          font: 'body',
        }}
      >
        <view.span>{name}</view.span>
        <view.span>{phoneNumber}</view.span>
      </view.div>
      <view.p css={{font: 'body', color: 'secondary'}}>{waitTime}</view.p>
      <view.div css={{marginTop: css.value('16px')}}>
        <VerificationCodes
          verificationCodes={verificationCodes}
          loading={verficationCodesLoading}
          error={verificationCodesError}
        />
      </view.div>
    </view.div>
  );
};
